import React, { useMemo, useState } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import {
  Box, Button, Container, Paper, TextField, Typography, Alert, CircularProgress,
} from '@mui/material';
import { familyTheme, FAMILY_NAVY } from './familyTheme';
import { parentApi } from './parentApi';
import BrandLogo from '../../components/BrandLogo';

export default function FamilyWelcome() {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const hint = useMemo(
    () => 'Use 8+ characters with upper, lower, a number, and a symbol.',
    []
  );

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!token) {
      setError('This invite link is missing. Ask your coordinator for a new one.');
      return;
    }
    if (password !== confirm) {
      setError('Passwords do not match.');
      return;
    }
    setLoading(true);
    try {
      const res = await parentApi.completeActivation(token, password);
      if (res.data?.success) {
        navigate('/login', { replace: true, state: { created: true } });
        return;
      }
      setError(res.data?.message || 'Could not create password.');
    } catch (err) {
      setError(err.response?.data?.message || 'This link is invalid or has expired.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <ThemeProvider theme={familyTheme}>
      <Box sx={{ minHeight: '100vh', bgcolor: 'background.default', py: 8 }}>
        <Container maxWidth="sm">
          <BrandLogo height={80} sx={{ mb: 2 }} />
          <Typography sx={{ color: FAMILY_NAVY, letterSpacing: 1, fontSize: 13, mb: 1 }}>
            Families
          </Typography>
          <Typography variant="h4" sx={{ mb: 1 }}>Welcome to BacchaPanti for families.</Typography>
          <Typography color="text.secondary" sx={{ mb: 3 }}>
            This login is for your family. Create a password, then you can open classes, homework, and reports.
          </Typography>
          <Paper sx={{ p: 3 }}>
            {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
            <Box component="form" onSubmit={onSubmit}>
              <TextField
                fullWidth
                type="password"
                label="New password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                helperText={hint}
                margin="normal"
                autoComplete="new-password"
              />
              <TextField
                fullWidth
                type="password"
                label="Confirm password"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                margin="normal"
                autoComplete="new-password"
              />
              <Button type="submit" fullWidth variant="contained" sx={{ mt: 2 }} disabled={loading}>
                {loading ? <CircularProgress size={22} color="inherit" /> : 'Create password'}
              </Button>
            </Box>
          </Paper>
          <Typography sx={{ mt: 2 }} variant="body2">
            Already set up? <Link to="/login">Sign in</Link>
          </Typography>
        </Container>
      </Box>
    </ThemeProvider>
  );
}
